'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-279/node_modules/@eliadmin/core/src/components/price-quotes/price-quote-request-form.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-279/node_modules/@eliadmin/core/src/components/price-quotes/price-quote-request-form.tsx").PriceQuoteRequestForm>>;
const Deferred = lazy(() => import("@eliadmin/module-original/priceQuoteRequestForm").then(m => ({ default: m.PriceQuoteRequestForm })));
export function PriceQuoteRequestForm(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

